const setModal = () => {
  const btnTriggers = document.querySelectorAll(".open-modal");
  const modal = document.querySelector("#modal");
  const modalContent = document.querySelector("#modal .modal-content");
  const iframe = document.querySelector("#modal iframe");
  const btnClose = document.querySelector("#modal .btn-close-modal");
  const html = document.querySelector("html");

  const setVideoIntoFrame = (video) => {
    video += "?autoplay=1&rel=0";
    iframe.src = video;
  };

  const openModal = (button) => {
    if (!button.dataset.video) {
      return;
    }

    let videoUrl;
    if (window.innerWidth < 991 && button.dataset.videoMobile) {
      videoUrl = button.dataset.videoMobile;
    } else {
      videoUrl = button.dataset.video;
    }

    modal.style.display = "flex";
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    html.style.overflow = "hidden";
    modalContent.classList.remove("fade-out");
    modalContent.classList.add("fade-in");
    setVideoIntoFrame(videoUrl);
  };

  const closeModal = () => {
    modalContent.classList.remove("fade-in");
    modalContent.classList.add("fade-out");
    modalContent.addEventListener(
      "animationend",
      () => {
        if (modalContent.classList.contains("fade-out")) {
          modal.style.display = "none";
          html.style.overflow = "auto";
        }
      },
      { once: true },
    );

    iframe.src = "";
  };

  btnTriggers.forEach((button) => {
    button.addEventListener("click", () => openModal(button));
  });

  if (btnClose) {
    btnClose.addEventListener("click", closeModal);
  }
};

export default setModal;
